import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: Repository): Interactor {
  return ({ milestone, completionDate }) =>
    present(
      repository
        .editMilestone(milestone, {
          ...milestone,
          state: "DONE",
          completedAt: completionDate,
        })
        .then((nextMilestone) => ({ milestone: nextMilestone, completionDate }))
        .catch(() => ({ milestone, completionDate })),
    );
}

export type { Interactor };

export { createInteractor };
